import script from "./HeaderNav.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderNav.vue?vue&type=script&setup=true&lang=js"

import "./HeaderNav.vue?vue&type=style&index=0&id=35e37639&lang=scss"

const __exports__ = script;

export default __exports__